// extracted by mini-css-extract-plugin
module.exports = {"aws-icon":"Styles_aws-icon__2sV6z","azure-icon":"Styles_azure-icon__13wRi","on-prem-icon":"Styles_on-prem-icon__2qQuS","gcp-icon":"Styles_gcp-icon__32naa"};